module.exports = "/packs/media/images/budget-04cded8b81eda21f6f07d4b9070d2a33.jpg";